import config from 'src/config';
import { LlmConfig } from 'src/types/global';
import { create } from 'zustand';

interface LlmState {
	llmId: string;
	llmLabel: string;
	llmConfig: LlmConfig;
	/** Every mode's supplemental children, keyed by function id. A session
	 * restored from the sidebar knows only its mode, so this resolves its ids. */
	supplementalFunctionIdsByMode: Record<string, string[]>;
	updateLlmId: (newId: string) => void;
	updateLlmLabel: (newLabel: string) => void;
	updateLlmConfig: (newConfig: LlmConfig) => void;
	updateSupplementalFunctionIdsByMode: (
		newIdsByMode: Record<string, string[]>,
	) => void;
	updateLlmState: (newState: {
		newId: string;
		newLabel: string;
		newConfig: LlmConfig;
	}) => void;
}

export const useLlmStore = create<LlmState>()((set) => ({
	llmId: config.DEFAULT_FUNCTION_ID,
	llmLabel: config.DEFAULT_FUNCTION_LABEL,
	llmConfig: config.DEFAULT_LLM_CONFIG,
	supplementalFunctionIdsByMode: {},
	updateLlmId: (newId) => set({ llmId: newId }),
	updateLlmLabel: (newLabel) => set({ llmLabel: newLabel }),
	updateLlmConfig: (newConfig) => set({ llmConfig: newConfig }),
	updateSupplementalFunctionIdsByMode: (newIdsByMode) =>
		set({ supplementalFunctionIdsByMode: newIdsByMode }),
	updateLlmState: ({ newId, newLabel, newConfig }) =>
		set({ llmId: newId, llmLabel: newLabel, llmConfig: newConfig }),
}));
